module.exports = __webpack_public_path__ + "static/biennale-ultra-light-ab4502ce41894ea62588756aead7e2aa.otf";